import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import Modal from "../../Modal";
import Nav from "./Nav";
import EmailForm from "./EmailForm";
import TextForm from "./TextForm";

@inject("messagingStorage")
@observer
class NewMessage extends React.Component {
  @observable visible = false;

  render() {
    const { messagingStorage, templates } = this.props;

    return [
      <button
        key="button"
        type="button"
        className="btn btn-pink btn-raised btn-long"
        onClick={this.handlerToggle}
      >
        COMPOSE
      </button>,
      <Modal
        key="modal"
        title="New Message"
        visible={this.visible}
        onClose={this.handlerToggle}
      >
        <div>
          <Nav
            messageType={messagingStorage.messageType}
            includeInactive={messagingStorage.includeInactive}
            onToggleMessageType={messagingStorage.toggleMessageType}
            onToggleIncludeInactive={messagingStorage.toggleIncludeInactive}
          />

          <div className="mb-15">
            {messagingStorage.messageType === "E-Mail" ? (
              <EmailForm
                files={messagingStorage.files}
                templates={templates}
                options={messagingStorage.groups}
                selectedUser={messagingStorage.selectedUser}
                subject={messagingStorage.subject}
                message={messagingStorage.message}
                onChangeSelectUsers={messagingStorage.changeSelectUsers}
                onChangeInput={messagingStorage.changeInput}
                onSelectTemplate={this.handlerSelectTemplate}
                onDropFile={messagingStorage.addFiles}
                onDeleteFile={messagingStorage.deleteFile}
              />
            ) : (
              <TextForm
                templates={templates}
                options={messagingStorage.groups}
                selectedUser={messagingStorage.selectedUser}
                message={messagingStorage.message}
                onChangeSelectUsers={messagingStorage.changeSelectUsers}
                onChangeInput={messagingStorage.changeInput}
                onSelectTemplate={this.handlerSelectTemplate}
              />
            )}
          </div>

          <div>
            <a
              className={classNames("btn btn-block btn-pink", {
                disabled:
                  messagingStorage.invalidate || messagingStorage.sending
              })}
              onClick={this.handlerSubmit}
            >
              SEND{messagingStorage.sending ? "ING..." : ""}
            </a>
          </div>
        </div>
      </Modal>
    ];
  }

  handlerToggle = () => (this.visible = !this.visible);

  handlerSubmit = () => this.props.messagingStorage.submit(this.handlerToggle);

  handlerSelectTemplate = data => {
    const value = data.value;
    const messagingStorage = this.props.messagingStorage;

    messagingStorage.toggleMessageType(
      value.message_type || messagingStorage.messageType
    );

    messagingStorage.changeInput({
      target: {
        name: "__message",
        value: value.message
      }
    });

    toastr.info("Template loaded");
  };
}

NewMessage.propTypes = {
  templates: PropTypes.array
};

export default NewMessage;
